import type { TourContext, TourDefinition } from "@/types/tour";
import { terminusAdminOnboarding } from "./terminus-admin-onboarding";
import { foundershubAdminOnboarding } from "./foundershub-admin-onboarding";
import { entrepreneurOnboarding } from "./entrepreneur-onboarding";
import { entrepreneurOpportunities } from "./entrepreneur-opportunities";
import { entrepreneurApplications } from "./entrepreneur-applications";
import { entrepreneurOpportunityDetail } from "./entrepreneur-opportunity-detail";
import { marketInsightsListTour } from "./market-insights-list";
import { marketInsightProcessingTour } from "./market-insight-processing";
import { committeePrePackageTour } from "./committee-pre-package";
import { committeeSessionTour } from "./committee-session";
import { postCommitteeTour } from "./post-committee";
import { projectLeadsTour } from "./project-leads";
import { dealflowListTour } from "./dealflow-list";

const allTours: TourDefinition[] = [
  terminusAdminOnboarding,
  foundershubAdminOnboarding,
  entrepreneurOnboarding,
  entrepreneurOpportunities,
  entrepreneurApplications,
  entrepreneurOpportunityDetail,
  marketInsightsListTour,
  marketInsightProcessingTour,
  committeePrePackageTour,
  committeeSessionTour,
  postCommitteeTour,
  projectLeadsTour,
  dealflowListTour,
];

export function getToursByContext(context: TourContext): TourDefinition[] {
  return allTours.filter((t) => t.context === context);
}

export function getTourById(tourId: string): TourDefinition | undefined {
  return allTours.find((t) => t.id === tourId);
}
